import { cloneDeep } from 'lodash'

import {
  STATS_INITIAL_STATE,
  TODAY_MATCHES_FETCH,
  TODAY_MATCHES_FETCH_CANCELED,
  TODAY_MATCHES_FETCH_ERROR,
  TODAY_MATCHES_FETCH_FULFILLED,
  TODAY_USERS_REGISTRATIONS_FETCH,
  TODAY_USERS_REGISTRATIONS_FETCH_CANCELED,
  TODAY_USERS_REGISTRATIONS_FETCH_ERROR,
  TODAY_USERS_REGISTRATIONS_FETCH_FULFILLED,
  USER_POSTS_VS_INTERACTIONS_FETCH,
  USER_POSTS_VS_INTERACTIONS_FETCH_CANCELED,
  USER_POSTS_VS_INTERACTIONS_FETCH_ERROR,
  USER_POSTS_VS_INTERACTIONS_FETCH_FULFILLED,
  USER_REGISTRATIONS_FETCH,
  USER_REGISTRATIONS_FETCH_CANCELED,
  USER_REGISTRATIONS_FETCH_ERROR,
  USER_REGISTRATIONS_FETCH_FULFILLED,
  USER_REGISTRATIONS_PER_DEVICE_FETCH,
  USER_REGISTRATIONS_PER_DEVICE_FETCH_CANCELED,
  USER_REGISTRATIONS_PER_DEVICE_FETCH_ERROR,
  USER_REGISTRATIONS_PER_DEVICE_FETCH_FULFILLED,
  USER_REGISTRATIONS_PER_INSTITUTION_FETCH,
  USER_REGISTRATIONS_PER_INSTITUTION_FETCH_CANCELED,
  USER_REGISTRATIONS_PER_INSTITUTION_FETCH_ERROR,
  USER_REGISTRATIONS_PER_INSTITUTION_FETCH_FULFILLED,
} from './Stats4NerdsActions'

export default (state = STATS_INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case TODAY_MATCHES_FETCH: {
      const newState = cloneDeep(state)
      newState.todayMatches = {}
      return newState
    }
    case TODAY_MATCHES_FETCH_CANCELED: {
      return state
    }
    case TODAY_MATCHES_FETCH_ERROR: {
      const newState = cloneDeep(state)
      newState.todayMatches = action.payload
      return newState
    }
    case TODAY_MATCHES_FETCH_FULFILLED: {
      const newState = cloneDeep(state)
      newState.todayMatches = action.payload
      return newState
    }

    case TODAY_USERS_REGISTRATIONS_FETCH: {
      const newState = cloneDeep(state)
      newState.todayUsersRegistrations = {}
      return newState
    }
    case TODAY_USERS_REGISTRATIONS_FETCH_CANCELED: {
      return state
    }
    case TODAY_USERS_REGISTRATIONS_FETCH_ERROR: {
      const newState = cloneDeep(state)
      newState.todayUsersRegistrations = action.payload
      return newState
    }
    case TODAY_USERS_REGISTRATIONS_FETCH_FULFILLED: {
      const newState = cloneDeep(state)
      newState.todayUsersRegistrations = action.payload
      return newState
    }

    case USER_POSTS_VS_INTERACTIONS_FETCH: {
      const newState = cloneDeep(state)
      newState.postsVsInteractions = {}
      return newState
    }
    case USER_POSTS_VS_INTERACTIONS_FETCH_CANCELED: {
      return state
    }
    case USER_POSTS_VS_INTERACTIONS_FETCH_ERROR: {
      const newState = cloneDeep(state)
      newState.postsVsInteractions = action.payload
      return newState
    }
    case USER_POSTS_VS_INTERACTIONS_FETCH_FULFILLED: {
      const newState = cloneDeep(state)
      newState.postsVsInteractions = action.payload
      return newState
    }

    case USER_REGISTRATIONS_FETCH: {
      const newState = cloneDeep(state)
      newState.registrations = {}
      return newState
    }
    case USER_REGISTRATIONS_FETCH_CANCELED: {
      return state
    }
    case USER_REGISTRATIONS_FETCH_ERROR: {
      const newState = cloneDeep(state)
      newState.registrations = action.payload
      return newState
    }
    case USER_REGISTRATIONS_FETCH_FULFILLED: {
      const newState = cloneDeep(state)
      newState.registrations = action.payload
      return newState
    }

    case USER_REGISTRATIONS_PER_DEVICE_FETCH: {
      const newState = cloneDeep(state)
      newState.registrationsPerDevice = {}
      return newState
    }
    case USER_REGISTRATIONS_PER_DEVICE_FETCH_CANCELED: {
      return state
    }
    case USER_REGISTRATIONS_PER_DEVICE_FETCH_ERROR: {
      const newState = cloneDeep(state)
      newState.registrationsPerDevice = action.payload
      return newState
    }
    case USER_REGISTRATIONS_PER_DEVICE_FETCH_FULFILLED: {
      const newState = cloneDeep(state)
      newState.registrationsPerDevice = action.payload
      return newState
    }

    case USER_REGISTRATIONS_PER_INSTITUTION_FETCH: {
      const newState = cloneDeep(state)
      newState.registrationsPerInstitution = {}
      return newState
    }
    case USER_REGISTRATIONS_PER_INSTITUTION_FETCH_CANCELED: {
      return state
    }
    case USER_REGISTRATIONS_PER_INSTITUTION_FETCH_ERROR: {
      const newState = cloneDeep(state)
      newState.registrationsPerInstitution = action.payload
      return newState
    }
    case USER_REGISTRATIONS_PER_INSTITUTION_FETCH_FULFILLED: {
      const newState = cloneDeep(state)
      newState.registrationsPerInstitution = action.payload
      return newState
    }

    default:
  }
  return state
}
